import React from 'react';
import ProductDashboardPage from '@/components/dashboard/ProductDashboardPage';

const UserTagesgeld = () => {
  return (
    <ProductDashboardPage
      title="Tagesgeld"
      productType="Tagesgeld"
      subtitle="Täglich verfügbar — Ihre Tagesgeldkonten mit flexibler Verfügbarkeit."
      ctaLabel="Tagesgeld eröffnen"
    />
  );
};

export default UserTagesgeld;
